<template>
  <div>
    <v-container fluid pa-0 grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-title>
              <h2 class="headline mr-3">Logs</h2>
              <!-- <v-switch
                :color="appButtonColor"
                hide-details
                v-model="play"
              ></v-switch> -->
              <v-spacer />
              <v-text-field
              v-model="search"
              label="Search"
              single-line
              :color="appButtonColor"
              ref="search"
              @keyup.enter="searchItem"
            >
            <template v-slot:prepend-inner class="align-end">
              <v-chip
                v-model="lookupSearch"
                close
                :color="appButtonColor"
                dark
                label
                class="mr-3"
                @input="removeChip"
                >
                {{ lookup }}
              </v-chip>
            </template>
              <template v-slot:append>
                <!-- <v-switch
                  :color="appButtonColor"
                  hide-details
                  single-line
                  class="mr-3"
                  v-model="byA360id"
                  :label="byA360id ? 'A360ID' : 'Username'"
                ></v-switch> -->
                <v-icon @click="searchItem" class="ml-2">search</v-icon>
              </template>
            </v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="logs"
              :rows-per-page-items="[13]"
              class="elevation-1 table-striped my-3"
              :pagination.sync="pagination"
              :search="search"
              no-data-text="Waiting for logs..."
              item-key="id"
            >
              <template slot="items" slot-scope="props">
                <tr class="row" @click="showActionDetails(props.item)">
                  <td>{{ new Date(props.item.createdAt).toLocaleString("en-US")  }}</td>
                  <td>{{ props.item.a360id }}</td>
                  <td>{{ appName(props.item.app) }}</td>
                  <td>{{ props.item.action }}</td>
                  <td>{{ props.item.actionOn }}</td>
                  <td>{{ props.item.actionBy }}</td>
                  <td>{{ props.item.ipAddress }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="actionDialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ actionItem.action }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  :color="appButtonColor"
                  label="Date"
                  :value="new Date(actionItem.createdAt).toLocaleString('en-US')"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  :color="appButtonColor"
                  label="Application"
                  :value="appName(actionItem.app)"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  :color="appButtonColor"
                  label="Action On"
                  :value="actionItem.actionOn"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  :color="appButtonColor"
                  label="Action By"
                  :value="actionItem.actionBy"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-textarea
                  :color="appButtonColor"
                  label="Previous Value"
                  :value="actionItem.currVal ? actionItem.currVal : 'NA'"
                  readonly
                ></v-textarea>
              </v-flex>
              <v-flex xs12 sm6>
                <v-textarea
                  :color="appButtonColor"
                  label="New Value"
                  :value="actionItem.newVal"
                  readonly
                ></v-textarea>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  :color="appButtonColor"
                  label="User Details"
                  :value="actionItem.browserDetails"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  :color="appButtonColor"
                  label="IP Address"
                  :value="actionItem.ipAddress"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="appButtonColor" flat @click="actionDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "Logs",
  data() {
    return {
      lookup: "",
      lookupSearch: false,
      realtime: false,
      byA360id: false,
      logSubscribe: "",
      logQueue: [],
      play: true,
      actionItem: {},
      actionDialog: false,
      searchLoading: true,
      groupError: false,
      permSuccess: false,
      search: "",
      userPerms: ["Super", "Admin", "User"],
      headers: [
        { text: "Created", sortable: true, value: "createdAt" },
        { text: "A360Id", sortable: true, value: "a360id" },
        { text: "App", sortable: true, value: "app" },
        { text: "Action", sortable: true, value: "action" },
        { text: "Action On", sortable: true, value: "actionOn" },
        { text: "Action By", sortable: true, value: "actionBy" },
        { text: "Ip Address", sortable: true, value: "ipAddress" }
      ],
      pagination: {
        descending: true,
        sortBy: "createdAt"
      }
    };
  },
  computed: {
    ...mapState("user", ["user", "state", "confirmed", "mersBranded", "logs"]),
    ...mapGetters("user", ["isAuthenticated", "userGroup", "adminOrSuper"]),
    appButtonColor() {
      return this.mersBranded ? "#33715A" : "#0B2A4A";
    },
    hasLogs() {
      return Boolean(this.logQueue.length)
    }
  },
  async created() {
    // this.$store.dispatch("accounts/allLogSubscribe")
    // this.logSubscribe = this.$store.subscribe((mutation, state) => {
    //     if (mutation.type === "accounts/addLog") {
    //         this.logQueue.push(mutation.payload)
    //         // if (!this.play) this.logQueue.push(mutation.payload)
    //         // else this.logs.push(mutation.payload)
    //     }
    // })
  },
  watch: {
    hasLogs(val) {
      if (val) this.moveLogs()
    },
    play(val) {
      if (val) this.moveLogs()
    }
  },
  methods: {
      async wait(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
      },
      async moveLogs() {
        if (this.hasLogs && this.play) {
            await this.wait(700)
            this.logs.push(this.logQueue.shift())
            this.moveLogs()
        }
      },
      appName(app) {
      return this.mersBranded && app === "MyAlerus"
        ? "Login"
        : this.mersBranded && app === "CSC"
        ? "CSR"
        : app;
    },
    async searchItem() {
      if (!this.search || this.lookupSearch) return
      if (this.search.length === 36) {
        await this.$store.dispatch("user/getLogs", this.search)
      }
      else {
        await this.$store.dispatch("user/getUserLogs", this.search)
      }
      this.lookupSearch = true
      this.lookup = this.search
      this.search = ""
    },
    removeChip() {
      this.$store.dispatch("user/logUnsubscribe")
      this.$store.commit("user/emptyLogs")
    },
    showActionDetails(item) {
      this.actionItem = item;
      this.actionDialog = true;
    }
  },
  beforeDestroy() {
    if (this.lookupSearch) this.removeChip()
    // this.$store.dispatch("accounts/allLogsUnsubscribe")
    // this.logSubscribe()
  },
};
</script>

<style lang="scss">
    .row {
        td {
            cursor: pointer;
        }
    }
</style>
